import { Button, Card, Col, Row, Space } from 'antd';
import { ReactComponent as BackIcon } from 'assets/icons/back.svg';
import { SH } from 'common/components';
import cardAccessService from 'common/services/card-access-service/card-access.service';
import configurationStore from 'common/stores/configuration/configuration.store';
import './gate-management.scss';
import { notification } from 'common/utils/notification';
import { GateOperationEnum, RelayOperationEnum } from 'common/services/card-access-service/card-access.service.types';
import {
  IGateConfiguration,
  IReaderConfiguration,
  IRelayConfiguration,
} from 'common/services/configuration-service/configuration.service.types';
import { useState } from 'react';

export const GateManagment = () => {
  const [buttonsState, setButtonsState] = useState<Record<string, boolean>>({});

  const formatRelayKey = (panelNumber: string, relayNumber: string, operation: RelayOperationEnum) => {
    return `${panelNumber}:${relayNumber}:${operation}:relay`;
  };

  const formatGateKey = (panelNumber: string, readerNumber: string, operation: GateOperationEnum) => {
    return `${panelNumber}:${readerNumber}:${operation}:reader`;
  };

  const onRelayClick = async (panelNumber: string, relayNumber: string, operation: RelayOperationEnum) => {
    try {
      await cardAccessService.toggleRelay(panelNumber, relayNumber, operation);
      notification.success({ message: 'Completed', duration: 5 });
      updateRelayButtonsState(panelNumber, relayNumber, operation);
    } catch (error: any) {
      if (error.response?.data?.errorCode === 'CannotToggleGate') {
        notification.destroy();
        notification.error({ message: error.response?.data.message });
        return;
      }
      throw error;
    }
  };

  const onGateClick = async (panelNumber: string, readerNumber: string, operation: GateOperationEnum) => {
    try {
      await cardAccessService.toggleGate(panelNumber, readerNumber, operation);
      notification.success({ message: 'Completed', duration: 5 });
      updateButtonsState(panelNumber, readerNumber, operation);
    } catch (error: any) {
      if (error.response?.data?.errorCode === 'CannotToggleGate') {
        notification.destroy();
        notification.error({ message: error.response?.data.message });
        return;
      }
      throw error;
    }
  };

  const getReaderName = (configuration: IReaderConfiguration) => {
    if (configuration.name) {
      return configuration.name;
    }

    return `Reader ${configuration.number} (${configuration.direction})`;
  };

  const updateRelayButtonsState = (panelNumber: string, relayNumber: string, operation: RelayOperationEnum) => {
    const targetKey = formatRelayKey(panelNumber, relayNumber, operation);

    setButtonsState((prev) => {
      const newState: Record<string, boolean> = {};
      Object.keys(prev).forEach((k) => {
        const [p, r] = k.split(':');

        if (p === panelNumber && r === relayNumber) {
          newState[k] = false;
        } else {
          newState[k] = prev[k];
        }
      });

      newState[targetKey] = true;

      return newState;
    });

    if (operation === RelayOperationEnum.EnergizeTimeOverride) {
      setTimeout(() => {
        setButtonsState((prev) => ({
          ...prev,
          [targetKey]: false,
        }));
      }, 1000);
    }
  };

  const updateButtonsState = (panelNumber: string, readerNumber: string, operation: GateOperationEnum) => {
    const targetKey = formatGateKey(panelNumber, readerNumber, operation);

    setButtonsState((prev) => {
      const newState: Record<string, boolean> = {};
      Object.keys(prev).forEach((k) => {
        const [p, r] = k.split(':');

        if (p === panelNumber && r === readerNumber) {
          newState[k] = false;
        } else {
          newState[k] = prev[k];
        }
      });

      newState[targetKey] = true;

      return newState;
    });

    if (operation === GateOperationEnum.Unlock) {
      setTimeout(() => {
        setButtonsState((prev) => ({
          ...prev,
          [targetKey]: false,
        }));
      }, 1000);
    }
  };

  const getRelayName = (relay: IRelayConfiguration) => {
    if (relay.name) {
      return relay.name;
    }

    return `Relay: ${relay.number}`;
  };

  const getRelayOptionsSecton = (gate: IGateConfiguration) => {
    return gate.relays?.map((relay) => {
      return (
        <div className="gate-options">
          <div className="name">
            <h1 className="h1">{getRelayName(relay)}</h1>
          </div>
          <div className="actions">
            <Button
              className={
                buttonsState[formatRelayKey(gate.panelNumber!, relay.number!, RelayOperationEnum.EnergizeTimeOverride)]
                  ? 'btn-green'
                  : 'btn'
              }
              onClick={() => onRelayClick(gate.panelNumber!, relay.number!, RelayOperationEnum.EnergizeTimeOverride)}>
              Trigger Open
            </Button>
            <Button
              className={
                buttonsState[formatRelayKey(gate.panelNumber!, relay.number!, RelayOperationEnum.HoldEnergized)] ? 'btn-green' : 'btn'
              }
              onClick={() => onRelayClick(gate.panelNumber!, relay.number!, RelayOperationEnum.HoldEnergized)}>
              Lock Open
            </Button>
            <Button
              className={
                buttonsState[formatRelayKey(gate.panelNumber!, relay.number!, RelayOperationEnum.Deenergized)] ? 'btn-green' : 'btn'
              }
              onClick={() => onRelayClick(gate.panelNumber!, relay.number!, RelayOperationEnum.Deenergized)}>
              Lock Close
            </Button>
          </div>
        </div>
      );
    });
  };

  const getAdditionalGates = () => {
    return configurationStore.configuration?.gates.filter((i) => i.name != configurationStore.currentUserGate?.name && i.useGateController);
  };

  const getGateOptionsSection = (gate: IGateConfiguration) => {
    if (!gate.readers) {
      return <></>;
    }

    return (
      <div>
        {gate.readers?.map((readerConfiguratioin) => {
          return (
            <div className="gate-options">
              <div className="name">
                <h1 className="h1">{getReaderName(readerConfiguratioin)}</h1>
              </div>
              <div className="actions">
                <Button
                  className={
                    buttonsState[formatGateKey(gate.panelNumber!, readerConfiguratioin.number, GateOperationEnum.Unlock)]
                      ? 'btn-green'
                      : 'btn'
                  }
                  onClick={() => onGateClick(gate.panelNumber!, readerConfiguratioin.number, GateOperationEnum.Unlock)}>
                  Trigger Open
                </Button>
                <Button
                  className={
                    buttonsState[formatGateKey(gate.panelNumber!, readerConfiguratioin.number, GateOperationEnum.UnlockHold)]
                      ? 'btn-green'
                      : 'btn'
                  }
                  onClick={() => onGateClick(gate.panelNumber!, readerConfiguratioin.number, GateOperationEnum.UnlockHold)}>
                  Lock Open
                </Button>
                <Button
                  className={
                    buttonsState[formatGateKey(gate.panelNumber!, readerConfiguratioin.number, GateOperationEnum.Lock)]
                      ? 'btn-green'
                      : 'btn'
                  }
                  onClick={() => onGateClick(gate.panelNumber!, readerConfiguratioin.number, GateOperationEnum.Lock)}>
                  Lock Close
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const getGates = () => {
    return configurationStore.configuration?.gates;
  };

  return (
    <div className="eiq-secure-traffic-page">
      <Row gutter={16}>
        <Col className="page-header">
          <SH.HotkeyLink
            to="/eiq-secure"
            className="go-back"
            label={
              <>
                <BackIcon />
                <span>Home</span>
              </>
            }
          />
        </Col>
      </Row>
      <Row gutter={16} className="traffic-content">
        <Col flex="auto">
          <Card className="eiq-card eiq-card-border gate-controller" style={{ width: '100%' }}>
            <div className="description">
              <h1 className="h1 title">GATE MANAGEMENT</h1>
              <div>
                <span>Trigger Open:</span> Opens the door once. Also use this button if you have held the door open or closed. The door will
                time out and return to normal operation.
              </div>
              <div>
                <span>Lock Open:</span> Keeps the door open until you click Trigger Open again to return the door to its normal function.
              </div>
              <div>
                <span>Lock Close:</span> Keeps the door closed until you click Trigger Open again to return the door to its normal function.
              </div>
            </div>

            {!!configurationStore.currentUserGate?.useGateController && (
              <div className="gates description">
                <h1 className="h1 doors">Doors</h1>

                {getGateOptionsSection(configurationStore.currentUserGate)}
                {!!getAdditionalGates() &&
                  getAdditionalGates()?.map((gate) => {
                    return getGateOptionsSection(gate);
                  })}
              </div>
            )}

            {!!getGates()?.flatMap((i) => i.relays ?? []).length && (
              <div className="gates description">
                <h1 className="h1 doors">Relays</h1>
                {getGates()?.map((gate) => getRelayOptionsSecton(gate))}
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};
